/* ============================================================
   ZENITH APPAREL — Product page JS
   ============================================================ */
(function() {
  /* ---- Scrolling gallery: filter + order by selected colour ----
     Media alt text carries "{Color} front/back/torso/detail/pose/scene";
     cells expose data-color + data-kind. On colour change we show only that
     colour's cells (plus untagged cells when nothing matches) ordered
     front, back, torso, detail, poses, scenes. */
  const gallery = document.querySelector('.product__media-scroll');
  const cells = gallery ? Array.from(gallery.querySelectorAll('.product__media-cell')) : [];

  /* Gender preference set by the header script (men/women tab, URL wins).
     On unisex products, female shots carry data-gender="female":
     women's context shows only those; men's (or no) context hides them.
     Products with no female-tagged media are unaffected. */
  function genderPref() {
    try { return localStorage.getItem('zenith_gender'); } catch (e) { return null; }
  }

  function applyGender(visible) {
    const female = visible.filter(c => (c.dataset.gender || '') === 'female');
    if (!female.length || female.length === visible.length) return visible;
    return genderPref() === 'women'
      ? female
      : visible.filter(c => (c.dataset.gender || '') !== 'female');
  }

  function filterGallery(color) {
    if (!gallery || !cells.length) return;

    let visible;
    if (color) {
      visible = cells.filter(c => c.dataset.color === color);
      if (!visible.length) visible = cells.filter(c => !c.dataset.color);
      if (!visible.length) visible = cells;
    } else {
      visible = cells;
    }
    visible = applyGender(visible);
    const visibleSet = new Set(visible);
    cells.forEach(c => c.classList.toggle('hidden', !visibleSet.has(c)));
    visible
      .slice()
      .sort((a, b) => (isNaN(parseInt(a.dataset.kind, 10)) ? 6 : parseInt(a.dataset.kind, 10)) - (isNaN(parseInt(b.dataset.kind, 10)) ? 6 : parseInt(b.dataset.kind, 10)))
      .forEach(c => gallery.appendChild(c));
  }

  function selectedColor() {
    const checked = document.querySelector('.product__swatch-input:checked');
    return checked ? checked.value : null;
  }

  filterGallery(selectedColor());

  const titleColorEl = document.getElementById('ProductTitleColor');

  /* ---- Colour ambience ----
     Tints the wash behind the top of the page to the selected colourway.
     The hex comes off the swatch input's data-hex, which Liquid fills from
     the same color-hex map the swatch itself uses, so the two can't drift. */
  const ambience = document.querySelector('.product__ambience');

  function setAmbience(input) {
    if (!ambience || !input) return;
    const hex = input.dataset.hex;
    if (hex) ambience.style.setProperty('--pdp-accent', hex);
  }

  setAmbience(document.querySelector('.product__swatch-input:checked'));

  document.querySelectorAll('.product__swatch-input').forEach(input => {
    input.addEventListener('change', () => {
      filterGallery(input.value);
      setAmbience(input);
      if (titleColorEl) { const _t = (document.querySelector('.product__title')?.dataset.title || '').toLowerCase(); titleColorEl.textContent = _t.includes(input.value.toLowerCase()) ? '' : ' — ' + input.value; }
      if (gallery) gallery.scrollTo({ left: 0, behavior: 'auto' });
      updateArrows();
    });
  });

  /* ---- Slider arrows ---- */
  const prevBtn = document.getElementById('MediaPrev');
  const nextBtn = document.getElementById('MediaNext');

  function slideWidth() {
    const cell = gallery ? gallery.querySelector('.product__media-cell:not(.hidden)') : null;
    return cell ? cell.getBoundingClientRect().width + 4 : 0;
  }

  function updateArrows() {
    if (!gallery || !prevBtn || !nextBtn) return;
    const maxScroll = gallery.scrollWidth - gallery.clientWidth - 2;
    prevBtn.disabled = gallery.scrollLeft <= 2;
    nextBtn.disabled = gallery.scrollLeft >= maxScroll;
  }

  if (gallery && prevBtn && nextBtn) {
    prevBtn.addEventListener('click', () => gallery.scrollBy({ left: -slideWidth(), behavior: 'smooth' }));
    nextBtn.addEventListener('click', () => gallery.scrollBy({ left: slideWidth(), behavior: 'smooth' }));
    gallery.addEventListener('scroll', () => requestAnimationFrame(updateArrows), { passive: true });
    updateArrows();
  }

  /* ---- Sticky add-to-cart bar ---- */
  const stickyBar = document.getElementById('ProductStickyBar');
  const infoPanel = document.querySelector('.product__info-inner');
  if (stickyBar && infoPanel && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 });
    io.observe(infoPanel);
    const stickyBtn = document.getElementById('ProductStickySubmit');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const mainBtn = document.querySelector('.product__add-btn');
        if (mainBtn && !mainBtn.disabled) mainBtn.click();
      });
    }
  }

  /* ---- Size label ("Size: XS") ---- */
  const sizeLabel = document.getElementById('SelectedSizeLabel');
  if (sizeLabel) {
    document.querySelectorAll('.product__size-input').forEach(input => {
      input.addEventListener('change', () => { sizeLabel.textContent = input.value; });
    });
  }

  /* ---- Size guide: reveals under the sizes, closes once one is picked ---- */
  const sizeGuideToggle = document.getElementById('SizeGuideToggle');
  const sizeGuidePanel = document.getElementById('SizeGuidePanel');
  if (sizeGuideToggle && sizeGuidePanel) {
    const setSizeGuide = open => {
      sizeGuideToggle.setAttribute('aria-expanded', String(open));
      if (open) {
        sizeGuidePanel.hidden = false;
        // Next frame so the height transition has a starting value to animate from.
        requestAnimationFrame(() => sizeGuidePanel.classList.add('is-open'));
      } else {
        sizeGuidePanel.classList.remove('is-open');
      }
    };

    sizeGuideToggle.addEventListener('click', () => {
      setSizeGuide(sizeGuideToggle.getAttribute('aria-expanded') !== 'true');
    });

    sizeGuidePanel.addEventListener('transitionend', event => {
      if (event.propertyName === 'grid-template-rows' && !sizeGuidePanel.classList.contains('is-open')) {
        sizeGuidePanel.hidden = true;
      }
    });

    document.querySelectorAll('.product__size-label').forEach(label => {
      label.addEventListener('click', () => setSizeGuide(false));
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') setSizeGuide(false);
    });
  }

  /* ---- Detail tabs ---- */
  const tabs = document.querySelectorAll('.product-tabs__tab');
  const panels = document.querySelectorAll('.product-tabs__panel');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.toggle('is-active', t === tab));
      panels.forEach(p => p.classList.toggle('is-active', p.dataset.panel === tab.dataset.tab));
    });
  });

  /* ---- Variant selection ----
     The section emits the variant map as [data-product-json]. The rule here is
     fail-closed: if the picked options cannot be resolved to a variant in that
     map, the add button disables and the hidden id is cleared. Silently posting
     whatever id the server rendered is how order #1001 shipped the wrong item —
     that path must stay impossible. */
  const form = document.getElementById('ProductForm');
  if (!form) return;

  const variantIdInput = document.getElementById('ProductVariantId');
  const addBtn = form.querySelector('.product__add-btn');
  const btnText = document.getElementById('ProductBtnText');

  const productJSON = document.querySelector('[data-product-json]');
  let productData = null;
  if (productJSON) {
    try { productData = JSON.parse(productJSON.textContent); } catch(e) {}
  }

  // Single-variant products render no option groups; their server-rendered id
  // is already the only correct one, so the matcher stays out of the way.
  const hasOptionGroups = !!form.querySelector('.product__option');

  function getSelectedOptions() {
    const options = {};
    form.querySelectorAll('.product__option').forEach(optGroup => {
      const name = optGroup.dataset.optionName;
      const checked = optGroup.querySelector('input:checked');
      if (name && checked) options[name] = checked.value;
    });
    return options;
  }

  function findMatchingVariant(options) {
    if (!productData || !Array.isArray(productData.variants)) return null;
    return productData.variants.find(variant => {
      return variant.options.every((val, i) => {
        const optName = productData.options[i];
        return options[optName] === val;
      });
    }) || null;
  }

  function setButton(enabled, label) {
    if (addBtn) addBtn.disabled = !enabled;
    if (btnText) btnText.textContent = label;
  }

  /* Ready-to-ship badge.

     Shows the real remaining count of the held buffer units for the SELECTED
     variant. Deliberately fails closed: if the variant does not track inventory,
     or the count is zero, or it is above the threshold, the badge is hidden.
     A stock claim that is not backed by a tracked number must never render —
     on a print-on-demand catalogue an always-on "low stock" label would be
     untrue on every product, every day. */
  const lowStockEl = document.getElementById('ProductLowStock');
  const lowStockThreshold = parseInt(lowStockEl?.dataset.lowStockThreshold || '5', 10);

  /* The count is reported PER COLOURWAY, not per size.

     Held stock is bought by colour with an assorted size split, so the true
     statement is "10 left in Flower Gray", not "2 left in Flower Gray / S".
     Shopify can only store inventory per variant, so the per-size split it
     holds is bookkeeping — summing it back up to the colourway is what makes
     the number on screen match what is physically on the shelf. */
  function colorOptionIndex() {
    if (!productData || !Array.isArray(productData.options)) return -1;
    return productData.options.findIndex(function(name) {
      return String(name).toLowerCase() === 'color' || String(name).toLowerCase() === 'colour';
    });
  }

  function colorStock(variant) {
    const idx = colorOptionIndex();
    if (idx < 0 || !productData || !Array.isArray(productData.variants)) {
      return { qty: Number(variant.inventory) || 0, label: '' };
    }
    const colorValue = variant.options[idx];
    let total = 0;
    productData.variants.forEach(function(v) {
      /* inventory comes from the zenith.ready_stock metafield and is null when
         no buffer count has been recorded — nulls contribute nothing, so a
         partially stocked colourway still reports only what is really held. */
      if (v.options[idx] === colorValue && v.inventory != null) {
        const n = Number(v.inventory);
        if (Number.isFinite(n) && n > 0) total += n;
      }
    });
    return { qty: total, label: colorValue };
  }

  function updateLowStock(variant) {
    if (!lowStockEl) return;

    /* Gate on the metafield-fed count, not inventory tracking — Shopify's
       tracking state says nothing about the buffer since Liquid cannot see
       TapStitch-fulfilled stock. null = no recorded buffer = no claim. */
    if (!variant || variant.inventory == null) {
      lowStockEl.hidden = true;
      lowStockEl.textContent = '';
      return;
    }

    const stock = colorStock(variant);

    if (stock.qty <= 0 || stock.qty > lowStockThreshold) {
      lowStockEl.hidden = true;
      lowStockEl.textContent = '';
      return;
    }

    const unit = stock.qty === 1 ? 'Only 1 left' : 'Only ' + stock.qty + ' left';
    lowStockEl.textContent = stock.label
      ? unit + ' ready to ship in ' + stock.label + ' — after that it is made to order'
      : unit + ' ready to ship — after that it is made to order';
    lowStockEl.hidden = false;
  }

  function updateVariant() {
    if (!hasOptionGroups) return;
    const variant = findMatchingVariant(getSelectedOptions());
    if (!variant) {
      if (variantIdInput) variantIdInput.value = '';
      setButton(false, 'Unavailable');
      updateLowStock(null);
      return;
    }
    updateLowStock(variant);
    if (variantIdInput) variantIdInput.value = variant.id;
    if (variant.available) {
      setButton(true, 'Add to cart');
    } else {
      setButton(false, 'Sold out');
    }
  }

  form.querySelectorAll('.product__size-input, .product__swatch-input').forEach(input => {
    input.addEventListener('change', updateVariant);
  });

  // Sync immediately so the id, button state and selection agree from first paint.
  updateVariant();

  /* ---- Add to cart ---- */
  if (form) {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      const variantId = variantIdInput?.value;
      const qty = parseInt(form.querySelector('.product__qty-input')?.value || '1');
      if (!variantId) return;

      const submitBtn = addBtn;
      const spinner = form.querySelector('.product__add-btn-spinner');
      if (submitBtn) submitBtn.disabled = true;
      if (spinner) spinner.classList.remove('hidden');

      /* Line item properties (bundle picks, personalisation) live on the form
         as properties[Name]. Collect them so the add carries them; empty values
         are skipped so a blank optional field adds nothing. */
      const properties = {};
      new FormData(form).forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim() !== '') properties[match[1]] = value;
      });

      try {
        await window.addToCart(parseInt(variantId), qty, properties);
        const cart = await window.fetchCart();
        window.updateCartCount(cart.item_count);
        // Repaint the drawer BEFORE opening it, so it never flashes the empty
        // state at someone who just added an item.
        await window.refreshCartDrawerDom();
        const cartDrawer = document.getElementById('CartDrawer');
        if (cartDrawer) {
          cartDrawer.classList.add('is-open');
          cartDrawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
      } catch (err) {
        console.error('Add to cart failed:', err);
      } finally {
        if (submitBtn) submitBtn.disabled = false;
        if (spinner) spinner.classList.add('hidden');
      }
    });
  }
})();

/* UGC video strip — play on scroll, pause off screen.

   Autoplay is driven here rather than by the autoplay attribute so only the
   clips actually on screen decode: nine simultaneously decoding videos is the
   difference between a page that scrolls and one that stutters on a phone.
   Muting is a hard requirement, not a preference — browsers reject autoplay
   with sound, and a rejected play() would leave a dead frozen frame. */
(function () {
  const items = Array.from(document.querySelectorAll('.ugc-strip__item'));
  if (!items.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  items.forEach(item => {
    const video = item.querySelector('video');
    const soundBtn = item.querySelector('.ugc-strip__sound');
    if (!video) return;

    /* Some browsers ignore the muted attribute when it arrives in markup;
       setting the property is what actually satisfies the autoplay policy. */
    video.muted = true;
    video.playsInline = true;
    video.loop = true;

    if (!soundBtn) return;
    soundBtn.addEventListener('click', () => {
      const nowMuted = !video.muted;
      video.muted = nowMuted;
      /* Unmuting one clip mutes the rest — overlapping audio from two videos
         is the fastest way to make someone leave the page. */
      if (!nowMuted) {
        items.forEach(other => {
          if (other === item) return;
          const otherVideo = other.querySelector('video');
          const otherBtn = other.querySelector('.ugc-strip__sound');
          if (otherVideo) otherVideo.muted = true;
          if (otherBtn) {
            otherBtn.setAttribute('aria-pressed', 'false');
            otherBtn.setAttribute('aria-label', 'Unmute video');
            other.classList.remove('is-unmuted');
          }
        });
        if (video.paused && !reduceMotion) video.play().catch(() => {});
      }
      soundBtn.setAttribute('aria-pressed', nowMuted ? 'false' : 'true');
      soundBtn.setAttribute('aria-label', nowMuted ? 'Unmute video' : 'Mute video');
      item.classList.toggle('is-unmuted', !nowMuted);
    });
  });

  if (reduceMotion) return;

  if (!('IntersectionObserver' in window)) {
    items.forEach(item => {
      const video = item.querySelector('video');
      if (video) video.play().catch(() => {});
    });
    return;
  }

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
          /* A clip scrolled past should restart clean next time, and a muted
             one that had sound turned on must not shout when it comes back. */
          if (!video.muted) {
            video.muted = true;
            const btn = entry.target.querySelector('.ugc-strip__sound');
            if (btn) {
              btn.setAttribute('aria-pressed', 'false');
              btn.setAttribute('aria-label', 'Unmute video');
            }
            entry.target.classList.remove('is-unmuted');
          }
        }
      });
    },
    { threshold: 0.5 }
  );

  items.forEach(item => observer.observe(item));
})();


/* ---- PDP gallery auto-cycle (31 Oct 2026) ----
   Loops the visible media cells (the selected colour's frames) every
   ZAC_PDP_MS, so the product page cycles the same mockup frames the
   collection cards do. Pauses while the shopper hovers, touches or
   focuses the gallery, backs off after they scroll or use the arrows,
   stops when the tab is hidden, and never runs under reduced motion. */
(function () {
  const gallery = document.querySelector('.product__media-scroll');
  if (!gallery) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const ZAC_PDP_MS = 1800;   /* dwell per frame */
  const USER_HOLD_MS = 6000; /* back off this long after the shopper takes over */

  let timer = null;
  let paused = false;
  let offscreen = false;
  let holdUntil = 0;
  let programmatic = 0;

  function visibleCells() {
    return Array.from(gallery.querySelectorAll('.product__media-cell:not(.hidden)'));
  }

  function currentIndex(cells) {
    const left = gallery.scrollLeft;
    let best = 0, bestDist = Infinity;
    cells.forEach((c, i) => {
      const d = Math.abs(c.offsetLeft - gallery.offsetLeft - left);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }

  function step() {
    if (paused || offscreen || document.hidden || Date.now() < holdUntil) return;
    const cells = visibleCells();
    if (cells.length < 2) return;
    const next = cells[(currentIndex(cells) + 1) % cells.length];
    programmatic = Date.now();
    gallery.scrollTo({ left: next.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
  }

  function start() {
    if (timer) return;
    timer = setInterval(step, ZAC_PDP_MS);
  }

  /* shopper takes over: arrows, drag/scroll, wheel */
  function userTookOver() { holdUntil = Date.now() + USER_HOLD_MS; }

  gallery.addEventListener('scroll', () => {
    if (Date.now() - programmatic > 900) userTookOver();
  }, { passive: true });
  gallery.addEventListener('wheel', userTookOver, { passive: true });
  gallery.addEventListener('pointerdown', userTookOver, { passive: true });
  ['MediaPrev', 'MediaNext'].forEach(id => {
    const btn = document.getElementById(id);
    if (btn) btn.addEventListener('click', userTookOver);
  });

  /* pause while the pointer or focus is on the gallery */
  const wrap = gallery.closest('.product__media-gallery') || gallery;
  wrap.addEventListener('mouseenter', () => { paused = true; });
  wrap.addEventListener('mouseleave', () => { paused = false; });
  wrap.addEventListener('focusin', () => { paused = true; });
  wrap.addEventListener('focusout', () => { paused = false; });
  wrap.addEventListener('touchstart', () => { paused = true; }, { passive: true });
  wrap.addEventListener('touchend', () => { paused = false; userTookOver(); }, { passive: true });

  /* only cycle while the gallery is actually on screen */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { offscreen = !e.isIntersecting; });
    }, { threshold: 0.25 });
    io.observe(wrap);
  }

  start();
})();
